import React from 'react';
import PropTypes from 'prop-types';
import TaxCalculatorCheckboxes from './TaxCalculatorCheckboxes';

class TaxCalculatorInputs extends React.Component {
  // Allow only numbers including decimals
  static handleKeyPress(e) {
    const DOT_CODE = 31;
    const DELETE_CODE = 46;
    const ZERO_CODE = 48;
    const NINE_CODE = 57;
    const charCode = (e.which) ? e.which : e.keyCode;
    const notDigit = charCode < ZERO_CODE || charCode > NINE_CODE;
    if (charCode > DOT_CODE && (charCode !== DELETE_CODE && notDigit)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    return true;
  }

  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className={`col-sm-12 col-md-2 col-md-offset-2 ${this.props.className}`}>
            <h3>Filing Status</h3>
            <TaxCalculatorCheckboxes
              isSingle={this.props.isSingle}
              updateFilingStatus={this.props.updateFilingStatus}
              mobile={this.props.mobile}
            />
          </div>
          <div className={`col-sm-12 col-md-2 col-md-offset-1 ${this.props.className}`}>
            <h3>Income</h3>
            <span className="dollar-bill">$</span>
            <input
              className="calculator-input"
              type="number"
              onChange={this.props.updateIncome}
              onKeyPress={TaxCalculatorInputs.handleKeyPress}
            />
          </div>
          <div className={`col-sm-12 col-md-4 ${this.props.className}`}>
            <h3>Number of Children</h3>
            <input
              className="calculator-input calculator-input-half-width"
              type="number"
              onChange={this.props.updateNumChildren}
              onKeyPress={TaxCalculatorInputs.handleKeyPress}
            />
          </div>
        </div>
        <div className="row">
          <div className={`col-sm-12 col-md-4 col-md-offset-4 ${this.props.className}`}>
            <button onClick={this.props.calculate}>Calculate</button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TaxCalculatorInputs.defaultProps = {
  className: '',
  mobile: false,
};

TaxCalculatorInputs.propTypes = {
  className: PropTypes.string,
  updateIncome: PropTypes.func.isRequired,
  updateNumChildren: PropTypes.func.isRequired,
  calculate: PropTypes.func.isRequired,
  isSingle: PropTypes.bool.isRequired,
  updateFilingStatus: PropTypes.func.isRequired,
  mobile: PropTypes.bool,
};

export default TaxCalculatorInputs;



// WEBPACK FOOTER //
// ./src-react/TaxCalculator/components/TaxCalculatorInputs.jsx